import { defineMessages } from 'react-intl'
import LineCameraPlusIcon from 'LuxKit/Icons/line/LineCameraPlusIcon'
import LineCoffeeIcon from 'LuxKit/Icons/line/LineCoffeeIcon'
import LineDrinksTrayIcon from 'LuxKit/Icons/line/LineDrinksTrayIcon'
import LineFootballBallIcon from 'LuxKit/Icons/line/LineFootballBallIcon'
import LineRestaurantIcon from 'LuxKit/Icons/line/LineRestaurantIcon'
import LineShoppingBagIcon from 'LuxKit/Icons/line/LineShoppingBagIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineUniversityIcon from 'LuxKit/Icons/line/LineUniversityIcon'

const messages = defineMessages({
  topAttractions: {
    id: 'BArEXtaG4C',
    defaultMessage: 'Top attractions',
    description: 'Explore category label for top attractions in trip planner',
  },
  restaurants: {
    id: 'Zhmx4evw7t',
    defaultMessage: 'Restaurants',
    description: 'Explore category label for restaurants in trip planner',
  },
  cafes: {
    id: 'NDvzKeBwp8',
    defaultMessage: 'Cafes',
    description: 'Explore category label for cafes in trip planner in the trip planner explore section',
  },
  parks: {
    id: 'IYg4UAgvsN',
    defaultMessage: 'Parks',
    description: 'Explore category label for parks in trip planner in the trip planner explore section',
  },
  shopping: {
    id: 'Zh0cTYm14Q',
    defaultMessage: 'Shopping',
    description: 'Explore category label for shopping in trip planner',
  },
  museums: {
    id: '9ORQZfVZJS',
    defaultMessage: 'Museums',
    description: 'Explore category label for museums in trip planner',
  },
  bars: {
    id: '7TBgAo45mI',
    defaultMessage: 'Bars',
    description: 'Explore category label for bars in trip planner in the trip planner explore section',
  },
  sports: {
    id: '8Mpq7w5KK4',
    defaultMessage: 'Sports',
    description: 'Explore category label for sports in trip planner in the trip planner explore section',
  },
})

export const exploreCategories = [
  {
    label: 'Top attractions',
    labelMessage: messages.topAttractions,
    icon: LineCameraPlusIcon,
  },
  {
    label: 'Restaurants',
    labelMessage: messages.restaurants,
    icon: LineRestaurantIcon,
  },
  {
    label: 'Cafes',
    labelMessage: messages.cafes,
    icon: LineCoffeeIcon,
  },
  {
    label: 'Parks',
    labelMessage: messages.parks,
    icon: LineTreesIcon,
  },
  {
    label: 'Shopping',
    labelMessage: messages.shopping,
    icon: LineShoppingBagIcon,
  },
  {
    label: 'Museums',
    labelMessage: messages.museums,
    icon: LineUniversityIcon,
  },
  {
    label: 'Bars',
    labelMessage: messages.bars,
    icon: LineDrinksTrayIcon,
  },
  {
    label: 'Sports',
    labelMessage: messages.sports,
    icon: LineFootballBallIcon,
  },
] as const

export type ExploreCategory = (typeof exploreCategories)[number]

type ExploreCategoriesLabels = {
  [K in (typeof exploreCategories)[number]['label']]: string
}

export const exploreAnalyticsCategoryLabels: ExploreCategoriesLabels = {
  'Top attractions': 'top-attractions',
  Restaurants: 'restaurants',
  Cafes: 'cafes',
  Parks: 'parks',
  Shopping: 'shopping',
  Museums: 'museums',
  Bars: 'bars',
  Sports: 'sports',
}

export function formatExploreQuery(
  place: { lePlaceName: string },
  category: ExploreCategory,
) {
  if (category.label === 'Sports') {
    return `Sports venues in ${place.lePlaceName}`
  }

  return `${category.label} in ${place.lePlaceName}`
}
